import { render, staticRenderFns } from "./UserFormSection.vue?vue&type=template&id=54ccd480&scoped=true&"
import script from "./UserFormSection.vue?vue&type=script&lang=js&"
export * from "./UserFormSection.vue?vue&type=script&lang=js&"
import style0 from "./UserFormSection.vue?vue&type=style&index=0&id=54ccd480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ccd480",
  null
  
)

export default component.exports